import { lazy, Suspense } from 'react';
const Layout = lazy(() => import('./Layout'));

const DashboardLayout = () => {
  return (
    <Suspense fallback={<>Loading</>}>
      <Layout />
    </Suspense>
  );
};

export default DashboardLayout;
